export const config = {
	apiKey: "AIzaSyAal4tRnalL8j-vci2porurGzPKH06vnxM",
	authDomain: "swipe-app-brinkhorst.firebaseapp.com",
	projectId: "swipe-app-brinkhorst",
	storageBucket: "swipe-app-brinkhorst.appspot.com",
	messagingSenderId: "815865349879",
	appId: "1:815865349879:web:d442f270d7baa1b688f5f2"
};
